import getNested from 'lodash.get';
import { CurrentStepReducerActionTypes } from '../redusers/current-step-reducer';
import { errorReducerActionTypes } from '../redusers/error-reducer';
import { useCallback, useContext } from 'react';
import { giftcardState } from '../Pages/Giftcard/client-state/giftcard-state-context';

type StepDependencies = {
  [key: number]: {
    requirement: string;
    errorType: errorReducerActionTypes;
    errorMessage: string;
  }[];
};

const defaultStepDependencies: StepDependencies = {
  1: [],
  2: [],
  3: [],
};

const useGiftcardChangeStep = (
  stepDependencies: StepDependencies = defaultStepDependencies
) => {
  const { state, dispatch } = useContext(giftcardState);

  const changeStep = useCallback(
    (newStep: number, { onlyBackward }: { onlyBackward?: boolean } = {}) => {
      if (newStep === state.currentStep) return;

      if (newStep < state.currentStep) {
        return dispatch({
          type: CurrentStepReducerActionTypes.CURRENT_STEP_UPDATE,
          payload: newStep,
        });
      }

      if (newStep > state.currentStep && onlyBackward) return;

      if (newStep > state.currentStep) {
        for (const [step, dependencies] of Object.entries(stepDependencies)) {
          for (const dependency of dependencies) {
            // Check step dependencies
            if (!getNested(state, dependency.requirement, undefined)) {
              // Return error if dependencies are not valid
              return dispatch({
                type: dependency.errorType,
                payload: dependency.errorMessage,
              });
            }
          }

          // Only check dependencies up to and including `newStep`
          if (Number(step) === Number(newStep)) break;
        }

        return dispatch({
          type: CurrentStepReducerActionTypes.CURRENT_STEP_UPDATE,
          payload: newStep,
        });
      }
    },
    [state, stepDependencies, dispatch]
  );

  return changeStep;
};

export default useGiftcardChangeStep;
